// import io from "socket.io-client"; // Disabled to stop WebSocket traffic

export const connectWebSocket = (onProgress) => {
  return new Promise((resolve, reject) => {
    // Provide a dummy socket to prevent errors but stop actual traffic
    const dummySocket = {
      id: 'disabled-socket',
      on: () => {},
      off: () => {},
      emit: () => {},
      close: () => {},
      disconnect: () => {}
    };
    
    // Immediately resolve with the dummy socket
    resolve(dummySocket);
  });
};
  

///
